'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const useFeature = (features, key) => {
  const getFeature = inputKey => {
    const feature = Object.keys(features).includes(inputKey);
    if (feature) {
      return {
        [inputKey]: (features === null || features === void 0 ? void 0 : features[inputKey]) || false
      };
    }
    return {
      [inputKey]: false
    };
  };
  return typeof key === 'string' ? getFeature(key) : key.reduce((acc, singleKey) => {
    return {
      ...acc,
      ...getFeature(singleKey)
    };
  }, {});
};

exports.useFeature = useFeature;
